import { useEffect } from "react";

import { AnyEntityId, EntityType } from "@mapmycustomers/shared/types/entity";

import {
  subscribe as subscribeAction,
  unsubscribe as unsubscribeAction,
} from "@app/store/uiSync/actions";

const useHideOnDelete = (
  entityType: EntityType,
  entityId: AnyEntityId,
  onHide: () => void,
  subscribe: typeof subscribeAction,
  unsubscribe: typeof unsubscribeAction
) =>
  useEffect(() => {
    const listener = {
      onDelete: (type: EntityType, entityIds: AnyEntityId[]) => {
        // If deleted record is currently displayed, hide it
        if (type === entityType && entityIds.includes(entityId)) {
          onHide();
        }
      },
    };
    subscribe({ entityTypes: [entityType], listener });
    return () => {
      unsubscribe({ entityTypes: [entityType], listener });
    };
  }, [entityId, entityType, onHide, subscribe, unsubscribe]);

export default useHideOnDelete;
